/* "Complete the service" PDP cross-sell (business/Shopify#58). Deferred; does nothing until the shell is near the
   viewport, then one fetch. Any failure or no match leaves Ella's "Related products" block as it is. */
if (!customElements.get('spo-xsell')) {
  class SpoXsell extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window) || !this.dataset.url) return;
      this.io = new IntersectionObserver(
        (entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          this.io.disconnect();
          this.load();
        },
        { rootMargin: '600px 0px 600px 0px' }
      );
      this.io.observe(this);
    }

    disconnectedCallback() {
      this.io?.disconnect();
    }

    async load() {
      try {
        const res = await fetch(this.dataset.url, { headers: { Accept: 'text/html' } });
        if (!res.ok) return;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const out = doc.querySelector('[data-spo-xsell-results]');
        if (!out || !out.querySelector('[data-spo-xsell-item]')) return;
        const body = this.querySelector('[data-spo-xsell-body]');
        body.replaceChildren(...out.childNodes);
        body.hidden = false;
        if (this.hasAttribute('data-hide-related')) {
          const rel = document.querySelector('product-recommendations[data-intent="related"]');
          rel?.closest('.shopify-section')?.setAttribute('hidden', '');
        }
      } catch (e) {
        /* keep today's block */
      }
    }
  }
  customElements.define('spo-xsell', SpoXsell);
}
